import { useTranslation } from "react-i18next";
import type { CurationState } from "../../../api/knowledgeData/knowledgeDataDecoders";
import Chip from "../../../ui/feedback/Chip";
import type { ChipTone } from "../../../ui/styles/chipStyles";

const STATE_TONE: Readonly<Record<CurationState, ChipTone>> = {
  withdrawn: "info",
  superseded: "info",
  proposed: "info",
  accepted: "success",
  rejected: "danger",
};

export default function CurationStateBadge({ state }: { state: CurationState }) {
  const { t } = useTranslation();
  return <Chip tone={STATE_TONE[state]}>{t(`data.states.${state}`)}</Chip>;
}
